module.exports = __webpack_public_path__ + "static/media/1021660.b469657c.png";